import { Link } from "react-router-dom";
import Sidebar from "./Sidebar";
import { FaExchangeAlt, FaLongArrowAltLeft } from "react-icons/fa";
import { IoSettingsOutline } from "react-icons/io5";
import { useState, useEffect } from "react";
import axios from "axios";

export default function Currency() {

    const [finalamount, setFinalAmount] = useState("");
    const [rateText, setRateText] = useState("");
    const [fromcurr, setfromcurr] = useState("USD");
    const [tocurr, settocurr] = useState("INR");

    const [theme, setTheme] = useState(localStorage.getItem("theme") || "dark");

    useEffect(() => {
        const savedTheme = localStorage.getItem("theme") || "dark";
        setTheme(savedTheme);
    }, []);

    const pageBg = theme === "dark" ? "dashboard-bg" : "bg-light";
    const cardBg = theme === "dark" ? "backgroundd-bg text-light" : "bg-white text-dark";
    const inputBg = theme === "dark" ? "bg-dark text-light" : "bg-light text-dark";
    const btnSecondary = theme === "dark" ? "btn btn-dark text-light" : "btn btn-gradientss text-light";
    const btnMain = theme === "dark" ? "btn btn-gradientss text-light" : "btn btn-gradientss text-light";
    const textColor = theme === "dark" ? "text-light" : "text-dark";

    const currentlist = [
        "USD", "AED", "AFN", "ALL", "AMD", "ANG", "AOA", "ARS", "AUD",
        "BDT", "BGN", "BHD", "BRL", "CAD", "CHF", "CNY", "EUR", "GBP",
        "HKD", "IDR", "ILS", "INR", "IQD", "JPY", "KRW", "KWD", "LKR",
        "MXN", "MYR", "NGN", "NOK", "NPR", "NZD", "OMR", "PHP", "PKR",
        "QAR", "RUB", "SAR", "SEK", "SGD", "THB", "TRY", "UAH", "USD",
        "VND", "ZAR"
    ];

    function submitdata(e) {

        e.preventDefault();

        const data = new FormData(e.currentTarget);

        const amount = data.get("amount");
        const curr1 = data.get("curr1");
        const curr2 = data.get("curr2");

        if (!amount || amount <= 0) {
            setFinalAmount("");
            setRateText("Please enter a valid amount");
            return;
        }

        axios
            .get(`https://v6.exchangerate-api.com/v6/5295ebb163d07ebdb2e901b9/latest/${curr1}`)
            .then((res) => {

                const rate = res.data.conversion_rates[curr2];
                const converted = (Number(amount) * rate).toFixed(2);

                setFinalAmount(converted);
                setRateText(`1 ${curr1} = ${rate} ${curr2}`);

            })
            .catch(() => {
                setRateText("Error fetching exchange rates");
            });
    }

    function swapcurrency() {

        setfromcurr(tocurr);
        settocurr(fromcurr);

        setFinalAmount("");
        setRateText("");

    }

    return (
        <>
            <title>Live Currency Converter – Exchange Rates Worldwide | TravelToolkit</title>
            <meta name="description" content="Convert currencies instantly with live exchange rates. TravelToolkit provides accurate and real-time currency conversion for all countries to help you travel smarter." />
            <meta name="keywords" content="currency converter live, exchange rate calculator, convert INR to USD, foreign exchange rates today, travel currency converter, global currency rates" />

            <meta property="og:title" content="Live Currency Converter – Exchange Rates Worldwide | TravelToolkit" />
            <meta property="og:site_name" content="traveltoolkit" />
            <meta property="og:url" content="https://traveltoolkit.online/Currency" />
            <meta property="og:description" content="Convert currencies instantly with live exchange rates. TravelToolkit provides accurate and real-time currency conversion for all countries to help you travel smarter." />
            <meta property="og:image" content="earth.gif"></meta>

            <meta name="twitter:card" content="app" />
            <meta name="twitter:site" content="@traveltoolkit" />
            <meta name="twitter:description" content="Convert currencies instantly with live exchange rates. TravelToolkit provides accurate and real-time currency conversion for all countries to help you travel smarter." />
            <meta name="twitter:app:country" content="India" />

            <div className="container-fluid p-0">
                <div className="row g-0">
                    <Sidebar />
                    <div className={`col-md-9 col-lg-10 ${pageBg} min-vh-100 p-3 offset-lg-2 offset-md-2`}>
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <div className="d-flex align-items-center gap-2">
                                <Link to="/Dashboard">
                                    <button className={btnSecondary}>
                                        <FaLongArrowAltLeft />
                                    </button>
                                </Link>
                                <h1 className={`${textColor} mb-0 h4`}>Currency Converter</h1>
                            </div>
                            <Link to="/Settings">
                                <button className="btn btn-gradientss text-light">
                                    <IoSettingsOutline />
                                </button>
                            </Link>
                        </div>
                        <div className={`card ${cardBg} mb-4 px-4 py-3`}>
                            <form onSubmit={submitdata}>
                                <label className={`${textColor} mb-1 small`}>
                                    Enter Amount
                                </label>
                                <input type="number" name="amount" className={`form-control ${inputBg} mb-3`} placeholder="Enter amount" required />
                                <div className="row align-items-end mb-3">
                                    <div className="col-md-5">
                                        <label className={`${textColor} mb-1 small`}>From</label>
                                        <select name="curr1" className={`form-select ${inputBg}`} value={fromcurr} onChange={(e) => setfromcurr(e.target.value)}>
                                            {currentlist.map((row) => (
                                                <option key={row} value={row}>
                                                    {row}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-2 text-center">
                                        <button type="button" className={`btn ${btnSecondary} mt-3`} onClick={swapcurrency}>
                                            <FaExchangeAlt />
                                        </button>
                                    </div>
                                    <div className="col-md-5">
                                        <label className={`${textColor} mb-1 small`}>To</label>
                                        <select name="curr2" className={`form-select ${inputBg}`} value={tocurr} onChange={(e) => settocurr(e.target.value)}>
                                            {currentlist.map((row) => (
                                                <option key={row} value={row}>
                                                    {row}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                {finalamount && (
                                    <div className="mb-3">
                                        <p className={`${textColor} mb-1`}>Converted Amount:</p>
                                        <h5 className="text-success">
                                            {finalamount}
                                        </h5>
                                        <small className="text-secondary">
                                            {rateText}
                                        </small>
                                    </div>
                                )}
                                <button type="submit" className={`btn ${btnMain} w-100`}>Convert</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}